import { recordRepository } from '../repositories/recordRepository';
import { schemaValidator } from '../validators/schemaEngine';

export const RecordService = {
  createRecord: async (projectId, type, payload) => {
    // اعتبارسنجی لایه دامنه پیش از تراکنش دیتابیس
    schemaValidator.validate(type, payload);
    return await recordRepository.create(projectId, type, payload);
  },

  reviseRecord: async (projectId, rootId, updatedPayload, reason) => {
    // اعتبارسنجی نسخه جدید پیش از ورود به مرز تراکنش اتمیک
    const currentVersions = await recordRepository.getHistoryByRootId(projectId, rootId);
    if (!currentVersions || currentVersions.length === 0) {
      throw new Error('پرونده اولیه برای ایجاد بازبینی جدید یافت نشد.');
    }
    const type = currentVersions[0].type;
    schemaValidator.validate(type, updatedPayload);

    return await recordRepository.revise(projectId, rootId, updatedPayload, reason);
  },

  getActiveRecords: async (projectId, type = null) => {
    return await recordRepository.getActiveRecords(projectId, type);
  },

  getRecordRevisionsHistory: async (projectId, rootId) => {
    return await recordRepository.getHistoryByRootId(projectId, rootId);
  }
};
